<template>
  <div id="nav">
    <el-container>
      <header-nav
        @JieSuo="JieSuo"
        @modify="modify"
        ref="setBooks"
        @ceratSetOfBooks="ceratSetOfBooks"
        @problemFeedback="problemFeedback"
        @projectEscalation="projectEscalation"
        :code="code"
      ></header-nav>
      <nav-bar v-if="isPageShow"></nav-bar>

      <el-container>
        <el-aside width="140px">
          <menu-nav></menu-nav>
        </el-aside>

        <el-main>
          <!-- 过期提示已经更改 :id='preventMessage?"elMainStyle":""'  -->
          <keep-alive>
            <router-view v-if="isPageShow" @successSaves="successSaves"></router-view>
          </keep-alive>

          <!-- <router-view v-if='!$route.meta.keepAlive'></router-view> -->
        </el-main>
      </el-container>
    </el-container>
    <message-verification v-if="messageVerificationShow" @CloseMessage="CloseMessage" :bookId="bookId" @closeMessage_f="closeMessage_f"></message-verification>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="700px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-loading="loading">
        <el-form ref="creatForm" :model="form" :rules="rulesForm" :inline="true">
          <el-form-item label="账套名称：" prop="alias">
            <el-input class="accountName" size="mini" placeholder="请输入账套名称" v-model="form.alias"></el-input>
          </el-form-item>
          <el-form-item label="会计制度：" prop="type">
            <el-select v-model="form.type" style="width:178px; " size="mini" :disabled="changeSend">
              <el-option v-for="(item,index) in accountingSystem" :value="item.type" :label="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用期间：" prop="startYearPeriod">
            <el-date-picker
              style="width:178px"
              :disabled="changeSend"
              v-model="dates.startYearPeriod"
              type="month"
              @change="handleMouthChange"
              placeholder="选择月"
              size="mini"
            ></el-date-picker>
          </el-form-item>
          <div class="creatButton_G">
            <el-button type="warning" class="creatButton" @click="handleQuxiao" v-if="isWithdrawShow">取消</el-button>
            <el-button class="creatButton minButton" @click="creatAccount">确认</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="账套解锁"
      :visible.sync="dialogVisible_YZ"
      width="30%"
      top="60px"
      class="default-dialog JS_dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <set-books @JieSuo="getMessage" @modify="modify" ref="setBooks"></set-books>
    </el-dialog>

    <el-dialog title="系统提示" :visible.sync="dialogVisible_prevent" width="550px" class="default-dialog">
      <span style="color:#ff5f5b;font-size: 14px;font-weight: bold;">{{preventMessage}}</span>
      <div style="text-align: right;margin-top: 20px;">
        <el-button class="secondaryButton" size="small" @click="dialogVisible_prevent=false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 系统公告 -->
    <system-update :sysData="sysData" @sysclose="sysclose"></system-update>
    <!-- 公告历史列表 -->
    <system-bulletin :defaultData="defaultData" @closed="close"></system-bulletin>
    <!-- 历史列表详情 -->
    <sysdetail></sysdetail>
    <!-- 现金流量新手指导 -->
    <novice-guide :isNoviceGuideDialogShow.sync="isNoviceGuideDialogShow"></novice-guide>
    <!-- 问题反馈 -->
    <ExistingProblems ref="ExistingProblems" />
    <!-- 项目上报 -->
    <ProjectReport ref="ProjectReport" />
    <!-- 系统更新弹框 -->
    <UpdateDialog :showVisibles.sync = "isUpdateDialogShow" :updateInfo = "updateInfo"/>
  </div>
</template>



<script>
import noviceGuide from "@/components/dialog/noviceGuide"
import headerNav from "@/components/main/HeaderNav"
import menuNav from "@/components/main/MenuNav"
import navBar from "@/components/main/NavBar"
import messageVerification from "@/components/dialog/messageVerification"
import setBooks from "@/components/dialog/setBooks"
import ExistingProblems from '@/components/dialog/ExistingProblems'
// --------------公告
import bus from "@/assets/utils/bus"
import systemBulletin from "@/components/dialog/SystemBulletin.vue"
import systemUpdate from "@/components/dialog/SystemUpdate.vue"
import sysdetail from "@/components/dialog/sysdetail.vue"
import ProjectReport from '@/components/dialog/ProjectReport'
import UpdateDialog from '@/components/dialog/updateDialog'

export default {
  components: {
    noviceGuide,
    headerNav,
    menuNav,
    navBar,
    messageVerification,
    setBooks,
    systemBulletin,
    systemUpdate,
    UpdateDialog,
    sysdetail,ExistingProblems,ProjectReport
  },
  provide() {
    return {
      bookObj: this.bookObj
    }
  },
  data() {
    return {
      updateInfo: {}, // 系统更新信息
      isUpdateDialogShow: false, // 系统更新弹框
      isNoviceGuideDialogShow: false, // 新手指导弹框
      bookObj: {
        allBooks: [] // 全部账套
      },
      code: "",
      dialogVisible_prevent: false,
      isPageShow: true, // 是否显示页面
      isWithdrawShow: false, // 是否显示取消按钮
      clickID: "", // 当前点击账套ID
      title: "创建账套",
      isCreat_CZT: false, // 是否是创建次账套
      dialogVisible_YZ: false, // 用户验证弹框
      messageVerificationShow: false,
      changeSend: false, // 控制调用接口
      bookId: "",
      loading: false, // 加载
      form: {
        alias: "", // 名称
        startYearPeriod: "", // 开始时间
        type: "" // 会计制度
      },
      dates: {
        startYearPeriod: "" //启用期间
      },
      accountingSystem: [],
      dialogVisible: false, // 修改账套弹框
      rulesForm: {
        alias: [
          {
            required: true,
            message: "请输入账套名称"
          }
        ],
        type: [
          {
            required: true,
            message: "会计制度不能为空！"
          }
        ],
        startYearPeriod: [
          {
            required: true,
            message: "启用期间不能为空！"
          }
        ]
      },
      // --------------------公告
      defaultData: {
        show: false
      },
      sysData: null,
      timer: "",
      msgdata: "",
      arr: [],
      index: 0
    }
  },

  created() {
    this.dialogVisible = JSON.parse(sessionStorage.isfirst)
    this.form.alias = sessionStorage.getItem("bookName_first")
    this.changeSend = false
    this.isCreat_CZT = false
    this.isWithdrawShow = false
    this.setLength()
    // this.$store.dispatch('getAccountInfo');

    // 读取本地缓存，没有就展开新手指导
    let firstLogin = localStorage.getItem("isNoviceGuideFirstShow")
    console.log(firstLogin)
    if (!firstLogin) {
      this.isNoviceGuideDialogShow = true
      localStorage.setItem("isNoviceGuideFirstShow", "1")
    }
  },
  computed: {
    protectionBook() {
      return this.$getSessionStorage("user").protectionBook
    },
    preventMessage() {
      let superPreventOperation = this.$store.getters.superPreventOperation
      if (this.$getSessionStorage("superPreventOperation") || superPreventOperation) {
        return superPreventOperation || this.$getSessionStorage("superPreventOperation").replace(/\"/g, "")
      } else {
        return false
      }
    },
    superPreventOperationState() {
      return this.$store.state.loadstatus.superPreventOperationState
    },
    rejectProblemCount() {
      return this.$store.state.loadstatus.rejectProblemCount
    },
    msg() {
      return this.$store.state.webSockets.msg
    },
    isHaveProblemNew() {
      return this.$store.state.webSockets.problem
    }
  },
  methods: {
    // ---------------系统公告开始
    // functimer(){
    //     this.$http
    //       .post(
    //         "problem/getChangeNum",
    //         { subId: localStorage.getItem("accountId") },
    //         { form: "houtai" }
    //       )
    //       .then(res => {
    //         if (res && res.data.code == 200) {
    //           this.code = res.data.data;
    //         }
    //       });

    //   const that=this
    //   let uid=JSON.parse(sessionStorage.getItem('user'))?JSON.parse(sessionStorage.getItem('user')).accountId:"";
    //   this.$http.post('msg/notify/getMsg', {systemType:1,userId:uid},{form:"houtai"}).then(res=>{
    //   	if(res && res.data.code == 200) {
    //       this.arr=res.data.data
    //       this.index =0;
    //       this.sysData=res.data.data[this.index]
    //   	}
    //   })
    // },

    // 项目上报
    projectEscalation() {
      this.$refs.ProjectReport.handleOpen()
    },

    // 问题反馈
    problemFeedback() {
      this.$refs.ExistingProblems.handleOpen()
    },

    close(val) {
      this.$set(this.defaultData, "show", val)
    },
    sysclose() {
      this.index++
      this.sysData = this.arr[this.index]
    },
    // ----------------------系统公告结束

    // 穿透公司设置保存更新账套
    successSaves(data) {
      this.$nextTick(() => {
        this.$refs.setBooks.$children[0].getBooks()
        this.$refs.setBooks.getAccountInfo()
      })
    },

    // 关闭短信验证
    closeMessage_f(val) {
      this.messageVerificationShow = false
    },
    handleMouthChange(val) {
      if (val) {
        this.$set(this.form, "startYearPeriod", this.$util.formatDate.format(val, "yyyMM"))
      }
    },
    // 取消
    handleQuxiao() {
      this.dialogVisible = false
    },
    // 获取解锁点击
    getMessage(data) {
      if (data.bookId) {
        if (data.protectionBook == 1) {
          this.$confirm("您即将向管理员请求验证, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              sessionStorage.removeItem("superGetMessage_110")
              this.bookId = data.bookId // 获取点击ID
              this.messageVerificationShow = true
            })
            .catch(() => {
              this.$message({
                type: "warning",
                showColse: true,
                message: "已取消操作"
              })
            })
        } else {
          this.CloseMessage(data.bookId)
        }
      }
    },
    // 获取全部账套长度,控制弹框显示
    setLength() {
      if (this.$getSessionStorage("notLoginEncryptedBookShow") || this.$getSessionStorage("dialogVisible_YZshow")) {
        this.$http.post("sys/login/getAllBooks", {}).then(res => {
          this.bookObj.allBooks = res.data.data
        })
      } else {
        this.$http.post("sys/login/getAllBooks", {}).then(res => {
          this.bookObj.allBooks = res.data.data
          if (res.data.data.length) {
            this.bookId = res.data.data[0].bookId
          }
          if (this.protectionBook == 1 && res.data.data.length == 1) {
            this.messageVerificationShow = true
            this.isPageShow = true
          } else if (this.protectionBook == 1 && res.data.data.length != 1) {
            this.dialogVisible_YZ = true
            this.isPageShow = false
          } else {
            this.messageVerificationShow = false
            this.isPageShow = true
          }
        })
      }
    },
    // 创建次账套
    ceratSetOfBooks(bookId) {
      if (bookId) {
        this.clickID = bookId
        this.dialogVisible = true
        this.title = "创建账套"
        this.form.alias = ""
        this.changeSend = false
        this.isWithdrawShow = true
        this.isCreat_CZT = true
      }
    },
    // 获取会计制度
    getAccountSystem() {
      this.$http.post("sys/accounting/list", {}).then(res => {
        this.accountingSystem = res.data.data
      })
    },
    // 解锁功能
    JieSuo(data) {
      if (data.bookId) {
        if (data.protectionBook == 1) {
          this.$confirm("您即将向管理员请求验证, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              sessionStorage.removeItem("superGetMessage_110")
              this.bookId = data.bookId // 获取点击ID
              this.messageVerificationShow = true
            })
            .catch(() => {
              this.$message({
                type: "warning",
                showColse: true,
                message: "已取消操作"
              })
            })
        } else {
          this.CloseMessage(data.bookId)
        }
      }
    },
    // 修改账套名称
    modify(data) {
      this.dialogVisible = true
      this.changeSend = true
      this.isWithdrawShow = true
      this.title = "修改账套"
      this.clickID = data.bookId
      this.$set(this.form, "alias", data.bookName)
      this.$set(this.form, "startYearPeriod", data.startYearPeriod)
      this.$set(this.dates, "startYearPeriod", data.startYearPeriod)
      this.$set(this.form, "type", data.accountingSystem)
    },
    // 关闭验证框/获取账套信息/菜单
    CloseMessage(data) {
      const sessionStorageCid = sessionStorage.getItem("cid")
      sessionStorage.setItem("cid", data)
      this.$http.post("createAccountSet/changeBook", { cid: data }).then(res => {
        if (res && res.data.code == 1) {
          this.messageVerificationShow = false
          this.$setSessionStorage("notLoginEncryptedBookShow", true)
          this.$store.dispatch("getAccountInfo")
          //查询菜单
          this.$http.post("sys/menu/getTree", {}).then(msg => {
            if (msg && msg.data.code == "1") {
              this.dialogVisible_YZ = false
              this.$store.commit("ADDROUTECHILD", msg.data.data)
              this.$setSessionStorage("menu", msg.data.data)
              this.$router.push({ path: "/home" })
              setTimeout(() => {
                location.reload()
              }, 500)
            }
          })
        } else {
          sessionStorage.setItem("cid", sessionStorageCid)
        }
      })
    },
    // 创建账套
    async creatAccount() {
      if (this.changeSend) {
        let valid = await this.$refs.creatForm.validate()
        if (valid) {
          try {
            this.loading = true
            this.$http.post("createAccountSet/updateNameByCid", { name: this.form.alias, id: this.clickID }).then(res => {
              if (res && res.data.code == 1) {
                this.$nextTick(() => {
                  this.$refs.setBooks.$children[0].getBooks()
                  this.$refs.setBooks.getAccountInfo()
                })
                this.dialogVisible = false
                this.changeSend = false
                this.$store.commit("IS_FIRST_LOGIN", false)
                this.$message({
                  type: "success",
                  message: res.data.msg,
                  showClose: true
                })
              }
              this.loading = false
            })
          } catch (e) {
            this.loading = false
          } finally {
          }
        }
      } else if (this.isCreat_CZT) {
        // 创建账套
        let valid = await this.$refs.creatForm.validate()
        if (valid) {
          try {
            this.loading = true

            this.$http
              .post("createAccountSet/UpdateSencondBook", { ...this.form, bookId: this.clickID })
              .then(res => {
                this.loading = false
                if (res.data.code == 1) {
                  this.dialogVisible = false
                  this.changeSend = false
                  this.$message({
                    type: "success",
                    message: "创建成功！",
                    showClose: true
                  })
                  this.CloseMessage(res.data.data)
                  // 创建完账套之后刷新账套列表，不再是之前的创建完并切换到创建的账套
                  // this.$refs.setBooks.$children[0].getBooks();
                }
              })
              .catch(() => (this.loading = false))
          } catch (e) {
            this.loading = false
          } finally {
          }
        }
      } else {
        let valid = await this.$refs.creatForm.validate()
        if (valid) {
          try {
            this.loading = true
            this.$http
              .post("createAccountSet/firstLanding", this.form)
              .then(res => {
                this.loading = false
                if (res && res.data.code == 1) {
                  this.$nextTick(() => {
                    this.$refs.setBooks.$children[0].getBooks()
                    this.$refs.setBooks.getAccountInfo()
                  })
                  this.dialogVisible = false
                  this.changeSend = false
                  this.$store.commit("IS_FIRST_LOGIN", false)
                  this.$message({
                    type: "success",
                    message: res.data.msg,
                    showClose: true
                  })
                }
              })
              .catch(() => (this.loading = false))
          } catch (e) {
            this.loading = false
          } finally {
          }
        }
      }
    },
    // 复制数字去掉逗号
    handleCopy(e) {
      let clipboardData = e.clipboardData || window.clipboardData
      // 如果粘贴板对象不存在，便停止操作
      if (!clipboardData) return
      let result = window.getSelection().toString()
      let textArr = result.split("")
      if (result && result.length) {
        for (var i = 0; i < textArr.length; i++) {
          if (textArr[i] === "," && i - 1 >= 0 && i + 3 < textArr.length) {
            let charList = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
            let num1 = charList.includes(textArr[i - 1])
            let num2 = charList.includes(textArr[i + 1])
            let num3 = charList.includes(textArr[i + 2])
            let num4 = charList.includes(textArr[i + 3])
            if (num1 && num2 && num3 && num4) {
              textArr.splice(i, 1)
            }
          }
        }
      }
      e.preventDefault()
      clipboardData.setData("text", textArr.join(""))
    }
  },
  mounted() {
    this.$nextTick(() => {
      let userId = this.$getSessionStorage("userId")
      if (!userId) return
      let objects = {
        userId: userId,
        systemType: "1",
        type: "msg"
      }
      this.$webSocket.sendMsg(objects, () => {})
    })
    // 全局注册copy事件
    document.addEventListener("copy", this.handleCopy)
  },

  watch: {
    rejectProblemCount: {
      handler(val) {
        console.log(val);
      },
      immediate: true
    },
    isHaveProblemNew(val, oldVal) {
      this.code = val
    },
    msg(val, oldVal) {
      if (!val) return
      // ---------------系统公告开始
      this.arr = val.filter(item=> !item.path)
      this.index = 0
      // 从后往前找出最新的消息信息
      for(let i=val.length-1; i>=0; i--) {
        if(val[i].path) {
          this.updateInfo = val[i]
          this.isUpdateDialogShow = true
          break
        }
      }
      this.sysData = this.arr[this.index]
    },
    dialogVisible(val) {
      if (val) {
        this.getAccountSystem()
      } else {
      }
    },
    superPreventOperationState: {
      deep: true,
      handler(val) {
        if (val) {
          this.dialogVisible_prevent = val
        }
      }
    },
    dialogVisible_prevent(val) {
      if (!val) {
        this.$store.commit("SUPERPREVENTFUNCTION", false)
      }
    }
  }
}
</script>

<style lang="less">
.el-month-table td.today .cell {
  font-weight: 100 !important;
  color: #606266 !important;
}
.el-month-table td.disabled .cell {
  font-weight: 100 !important;
  color: #c0c4cc !important;
}
.el-month-table td.current:not(.disabled) .cell {
  color: #409eff !important;
}
.el-month-table td .cell:hover {
  color: #409eff !important;
}
#nav {
  height: 100%;
  overflow: hidden;
  position: relative;
  .el-container,
  .el-container {
    height: 100%;
  }

  .el-main {
    height: calc(100% - 122px);
    padding: 0 20px;
    background-color: #eee;
    margin-top: 122px;
  }
  #elMainStyle {
    height: calc(100% - 166px);
    padding: 0 20px;
    background-color: #eee;
    margin-top: 166px;
  }
  .creatButton_G {
    text-align: center;
    .creatButton {
      display: inline-block;
      width: 140px;
      margin-top: 30px;
    }
  }
  .JS_dialog {
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue